import React from 'react'
import './UploadPopup.css';
import Close from "../../../site_media/images/icons8-close-window-24.png";

const Modal = ({ handleClose, show, children, type }) => {
    const showHideClassName = show ? "modal-up display-block" : "modal-up display-none";

    return (
        <div className={showHideClassName}>
            <div className="upload-popup-background" onClick={handleClose}>

            <section className={type === "video" ? "upload-popup-main-video d-flex" : "upload-popup-main d-flex"}>
                <img className="upload-popup-close" src={Close} alt={"X"} onClick={handleClose} />
                {children}
            </section>
            </div>
        </div>
    );
};

export default Modal;